__turbopack_context__.v({
  "body": "AJVEzG_body",
  "closeButton": "AJVEzG_closeButton",
  "content": "AJVEzG_content",
  "footer": "AJVEzG_footer",
  "header": "AJVEzG_header",
  "headerWithIcon": "AJVEzG_headerWithIcon",
  "icon": "AJVEzG_icon",
  "iconTitle": "AJVEzG_iconTitle",
  "multiStepTitle": "AJVEzG_multiStepTitle",
  "negativeButton": "AJVEzG_negativeButton",
  "root": "AJVEzG_root",
  "title": "AJVEzG_title",
});
